import { ValuesType } from "../Types/InitialStateType"

export function formDataFilterFormatterAsPerModel<T>(formData: ValuesType[], model: T) {
  let filter = ""
  let method = formData[0]?.searchMethod ?? "contains";
  let operator = formData[0]?.searchOperator ?? "or";

  //If block use for global search
  //Else use for value for exact properties 
  //Method can be contains or equal
  //Operator can be and/or
  if (!formData[0]?.data) {
    Object.getOwnPropertyNames(model).forEach((val) => {
      if (Array.isArray(formData)) {
        filter += `${method}(tolower(${val}),tolower('${formData[0].value}')) ${operator} `
      } else {
        filter += `${method}(tolower(${val}),tolower('${formData}')) ${operator} `
      }
    })
  } else {
    Object.entries(model as any).forEach(([key, value]) => {
      filter += `${method}(tolower(${key}),tolower('${formData[0].data[key]}')) ${operator} `
    })
  }

  if (filter.endsWith(`${operator} `)) {
    filter = filter.substring(0, filter.lastIndexOf(`${operator} `))
  }

  return encodeURIComponent(filter)
}

export function formDataFilterFormatterWithoutModel(formData: ValuesType[]) {
  let filter = ""

  if (Array.isArray(formData)) {
    filter += `${formData[0].value}`
  } else {
    filter += `${formData}`
  }


  return encodeURIComponent(filter);
}

